<template>
  <footer id="footer" class="utb-footer mt8">
    <div class="utb-footer-content" :class="color">
      <p class="small-p">© {{year}} Unite the Bride</p>
      <p class="small-p">All Rights Reserved</p>
      <p class="small-p">Unite the Bride is a Non-Profit Organization</p>
      <br>
      <!-- <p class="small-p"><a href="#">Privacy Policy</a> · <a href="#">Terms of Service</a></p> -->
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'dark'
    }
  },

  computed: {
    year() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/colors';

.utb-footer-content {
  min-height: 8em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: map-get($colors, gray0);
  background-color: map-get($colors, gray9);

  &.light {
    color: map-get($colors, gray9);
    background-color: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue